<template>
  <div id="app" v-cloak>
    <div class="container">
      <v-row class="search-wrapper" :gutter="10">
        <v-col :lg="12" :md="12" :sm="12" :xs="24">
          <v-text-field
            placeholder="Filter by Name"
            icon="search"
            v-model="filter"
          ></v-text-field>
        </v-col>
      </v-row>
      <el-col class="col-space" :lg="6" :md="6" :sm="6" :xs="24">
        &nbsp;
      </el-col>

      <el-col :lg="6" :md="6" :sm="6" :xs="24">
        <v-select
          :items="options"
          v-model="sort"
          item-text="label"
          item-value="value"
          label="label"
          dense
          outlined
          menu-props="auto"
        ></v-select>
      </el-col>

      <!-- search wrapper -->

      <v-row :gutter="10">
        <v-col v-for="(player, idx) in getPlayers" :key="idx" cols="12">
          <div class="box">
            <div>{{ player.name }}</div>
            <div class="box__subtitle">{{ player.sport }}</div>
            <div class="box__subtitle">{{ player.views }} views</div>
          </div>
        </v-col>

        <v-col v-if="getPlayers.length === 0" :xs="24" :sm="24" :md="24">
          <div class="box box__empty">No Match Found</div>
        </v-col>
      </v-row>
      <!-- results -->
    </div>
    <!-- container -->
  </div>
  <!-- #app -->
</template>
<style scoped>
[v-cloak] {
  display: none;
}

body {
  margin: 0;
  padding: 0;
  background-color: #f3f5f7;
  font-family: "Open Sans", sans-serif;
}

.search-wrapper {
  margin: 10px 0;
}

.col-space {
  content: "&nbsp;";
  @media screen and (max-width: 767px) {
    display: none;
  }
}

.container {
  max-width: 980px;
  margin: 20px auto;
  @media screen and (max-width: 1050px) {
    width: 95%;
  }
}

.box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  min-height: 150px;
  border-radius: 5px;
  background-color: white;
  margin-bottom: 10px;
}

.el-select {
  width: 100%;
}
</style>
<script>
// Thanks Dev Coffee! :)
// https://www.youtube.com/watch?v=VPUdtEf3oXI
export default {
  computed: {
    getPlayers() {
      var players = this.players.filter((player) => {
        return player.name.toLowerCase().includes(this.filter.toLowerCase());
      });

      if (this.sort == "views") {
        return players.sort(function(a, b) {
          return b.views - a.views;
        });
      } else {
        return players;
      }
    },
  },
  data() {
    return {
      filter: "",
      sort: "",
      options: [
        { label: "Default", value: "none" },
        { label: "Most Viewed", value: "views" },
      ],
      players: [
        { name: "Charles Wilson", sport: "Baseball", views: 312 },
        { name: "Tony Domo", sport: "Football", views: 23121 },
        { name: "Rump Baker", sport: "Basketball", views: 231 },
        { name: "Brad Pitt", sport: "Acting", views: 443 },
        { name: "Kermit the Frog", sport: "Frogball", views: 403 },
        { name: "Taylor Swift", sport: "Singing", views: 8843 },
      ],
    };
  },
};
</script>
